import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { path: '/', label: '首页' },
    { path: '/category/movie', label: '电影' },
    { path: '/category/tv', label: '电视剧' },
    { path: '/category/variety', label: '综艺' },
    { path: '/category/anime', label: '动漫' },
    { path: '/about', label: '关于我们' },
  ],
  quality: [
    { label: '蓝光画质' },
    { label: '4K超清' },
    { label: '超清画质' },
    { label: '高清画质' },
    { label: '流畅播放' },
  ],
  support: [
    { label: '常见问题' },
    { label: '播放帮助' },
    { label: '意见反馈' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-heading text-background-50">90影院</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              90影院致力于为广大影迷提供高清、超清、4K、蓝光画质的影视资源，电影电视剧综艺动漫免费在线观看，播放流畅不缓冲，全集持续更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">画质服务</h4>
            <ul className="space-y-2.5">
              {footerLinks.quality.map((item) => (
                <li key={item.label}>
                  <span className="text-sm text-foreground-400">{item.label}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助与支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((item) => (
                <li key={item.label}>
                  <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-foreground-700/30">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 90影院 版权所有 | 本站内容仅供学习交流，请支持正版
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}